import projectModel from "../../../../models/custom-vision/custom-vision.projects.model";
import ViewBase from '../../../view-base.view';
import CommonFooterComponent from '../common-footer.component';

export default function CVProjectEditView() {
  ViewBase.call(this);

  let _hasData = false;
  let inputDataModel = { projectName: "", projectDescription: "" };
  let selectedProjectId = 0;

  let _onPopupClose = (e) => { };
  let _onSaveComplete = (e) => { };

  let _cancel = (e) => {
    _onPopupClose(e);
  }

  let _save = (e) => {
    // Form validation
    if (!this.validateForm(e)) {
      return false;
    }

    projectModel.editProject(
      (result) => {
        _onSaveComplete(result);
      },
      (error) => {
        this.handleError(error);
      },
      selectedProjectId,
      inputDataModel.projectName,
      inputDataModel.projectDescription
    );
  }

  let _getProjectName = (e) => {
    inputDataModel.projectName = e.target.value;
  }

  let _getProjectDescription = (e) => {
    inputDataModel.projectDescription = e.target.value;
  }

  let _loadProject = () => {
    projectModel.getProjectInfo(
      (result) => {
        selectedProjectId = result.id;
        inputDataModel.projectName = result.name;
        inputDataModel.projectDescription = result.description;
      }, (error) => {
        selectedProjectId = 0;
        inputDataModel = { projectName: "", projectDescription: "" };

        this.handleError(error);
      },
      selectedProjectId);
  }

  let _checkData = () => {
    if (selectedProjectId > 0) {
      _hasData = true;
    }
  }

  return {
    oninit: (vnode) => {

      if (vnode.attrs.onPopupClose) {
        _onPopupClose = vnode.attrs.onPopupClose;
      }

      if (vnode.attrs.onSaveComplete) {
        _onSaveComplete = vnode.attrs.onSaveComplete;
      }

      if (vnode.attrs.projectId) {
        selectedProjectId = vnode.attrs.projectId;

        _loadProject();
      }

    },
    view: () => {
      _checkData();

      return [
        !_hasData &&
        m('span', this.getText("EM00000141", "No records found.")),

        _hasData &&
        m('.row',
          m('col-md-12',
            m('.card',
              m('.card-body',
                m('form#mainForm.needs-validation[novalidate]',
                  m('.row.col-md-12',
                    m('.col-md-12.mt-4',
                      m('label.form-label', this.getText("LT00000011", "Name"), m('span.redText', "*")),
                      m('input[required][maxlength=50][type=text][placeholder=' + this.getText("LT00000011", "Name") + '][value="' + inputDataModel.projectName + '"].form-control.form-control-bg', { onchange: _getProjectName }),
                      m('.invalid-feedback', this.getText("LT00000134XX", "Please enter a name for the project."))
                    ),
                    m('.col-md-12.mt-4',
                      m('label.form-label', this.getText("LT00000012", "Description")),
                      m('textarea#txtContent.form-control.form-control-bg',
                        {
                          placeholder: this.getText("LT00000012", "Description"),
                          onchange: _getProjectDescription,
                          style: "height: 185px;",
                          maxlength: 255
                        },
                        inputDataModel.projectDescription
                      )
                    )
                  )
                )
              ),
              m(CommonFooterComponent, {
                actionHandler: _save,
                cancelHandler: _cancel,
              }),
            )
          ),
        ),
        this.getBaseViews()
      ];
    },
  };
}
